module.exports = (__webpack_require__(0))(256);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/widgets/TimelineWidget.js from dll-reference girder_lib
// module id = 44
// module chunks = 0